import clsx from 'clsx'
import { useCallback } from 'react'

import { Flex } from 'components/common/flex/Flex'
import { ReactComponent as LinkIcon } from 'components/documentsContainer/documents/document/assets/link-icon.svg'
import { ReactComponent as PDFIcon } from 'components/documentsContainer/documents/document/assets/pdf-icon.svg'
import { ReactComponent as PPTIcon } from 'components/documentsContainer/documents/document/assets/ppt-icon.svg'
import { ReactComponent as VideoClipIcon } from 'components/documentsContainer/documents/document/assets/video-clip-icon.svg'
import styles from 'components/documentsContainer/documents/document/Document.module.scss'
import { DocumentDto } from 'types/documents'

interface Props {
  document: DocumentDto
}

export const Document = ({ document }: Props) => {
  const handleLinkClick = useCallback(() => {
    const isProduction = window.location.hostname === 'playground.coke.com';
    const documentUrl = document.url? document.url : isProduction ? document.prodUrl : document.stageUrl
    window.open(documentUrl, '_blank')
  }, [document])

  return (
    <Flex align="center" justify="between" gap={16} className={styles.container} onClick={handleLinkClick}>
      <Flex align="center" gap={16}>
        {document.fileType === 'PDF' && <PDFIcon className={styles.documentIcon} />}
        {document.fileType === 'PPTX' && <PPTIcon className={styles.documentIcon} />}
        {document.fileType === 'MP4' && <VideoClipIcon className={clsx(styles.documentIcon, 'text-[#F40000] fill-[#F40000] stroke-[#F40000]')} />}
        <span className={styles.documentTitle}>
          {document.documentName}
        </span>
      </Flex>
      <LinkIcon className={styles.linkIcon} />
    </Flex>
  )
}
